angular.module('tgaAdmin').controller('DivisionController', [
  '$scope',
  '$state',
  'divisionService',
  'userService',
  'flashService',
  'Papa',
  'modalService',
  '$translate',
  function ($scope, $state, divisionService, userService, flashService, Papa, modalService, $translate) {
    $scope.showBack = true;

    $scope.data = {
      alerts: [],
      division_id: $state.params.division_id || null,
      divisionTypes: [
        {
          id: 'text',
          name: 'Text Input',
        },
        {
          id: 'dropdown',
          name: 'Dropdown',
        },
      ],
      statusOptions: [
        {
          id: true,
          name: 'Enabled',
        },
        {
          id: false,
          name: 'Disabled',
        },
      ],
      answerSortableOptions: {
        items: '.input-group',
        containment: 'parent',
        revert: 250,
        forcePlaceholderSize: true,
        tolerance: 'pointer',
        cursor: 'move',
        handle: '.handle',
        placeholder: 'ui-sortable-placeholder',
        helper: 'original',
        scroll: false,
      },
    };

    $scope.viewmodel = {
      name: null,
      status: true,
      options: [],
    };

    $scope.initialize = function () {
      if ($scope.data.division_id) {
        divisionService.getDivision($scope.data.division_id).then((division) => {
          $scope.viewmodel = division;
          $scope.title = `<span class="text-muted">Edit Division /</span> ${$scope.viewmodel.name}`;
        });
      }
    };

    $scope.actions = {
      removeOption(option) {
        const index = $scope.viewmodel.options.indexOf(option);
        $scope.viewmodel.options.splice(index, 1);
      },
      deleteDivision() {
        modalService
          .showModal(
            {
              title: 'Delete Division?',
              message: 'Are you sure you want to delete this division?',
              closeButton: 'No',
              actionButton: 'Yes',
            },
            {
              backdrop: true,
              keyboard: true,
              animation: false,
            },
          )
          .then(
            () => {
              $scope.deleting = true;
              divisionService.deleteDivision($scope.data.division_id).then(
                () => {
                  flashService.set('<span class="fa fa-check"></span> Division deleted.', 'success');
                  $state.go('v1.division');
                },
                (error) => {
                  $scope.actions.createAlert(
                    `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
                    'danger',
                  );
                  $scope.deleting = false;
                },
              );
            },
            () => {},
          );
      },
      addDivisionOption() {
        $scope.viewmodel.options.push({ name: null });
      },
      changeDivisionType() {
        if ($scope.viewmodel.type === 'text') {
          $scope.viewmodel.options = [];
        } else {
          $scope.actions.addDivisionOption();
        }
      },
      submit(form) {
        form.submitted = true;

        $scope.data.alerts = [];

        if (form.$invalid) {
          $scope.actions.createAlert(
            `<span class="fa fa-exclamation-triangle"></span> ${$translate
              .instant('common.check_form_for_errors')
              .toString()}`,
            'danger',
          );
          return;
        }

        $scope.processing = true;

        if ($scope.data.division_id) {
          $scope.viewmodel.division_id = $scope.data.division_id;
          divisionService.updateDivision($scope.viewmodel).then(
            () => {
              flashService.set('<span class="fa fa-check"></span> Division updated.', 'success');
              $state.go('v1.division');
            },
            (error) => {
              $scope.actions.createAlert(
                `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
                'danger',
              );
              $scope.processing = false;
            },
          );
        } else {
          divisionService.addDivision($scope.viewmodel).then(
            () => {
              flashService.set('<span class="fa fa-check"></span> Division created.', 'success');
              $state.go('v1.division');
            },
            (error) => {
              $scope.actions.createAlert(
                `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
                'danger',
              );
              $scope.processing = false;
            },
          );
        }
      },
      createAlert(msg, type) {
        $scope.data.alerts = [];
        $scope.data.alerts.push({
          msg,
          type,
        });
      },
    };

    $scope.initialize();
  },
]);
